import React from "react"
import { FormField } from "src/features/calculator/components/field/FormField"
import styled from "styled-components"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { CalculationSchema } from "src/features/calculator/schema"

type Props = {
  customerTransferFeeRate: number
  exCustomerTransferFeeRate: number
  setValue: UseFormSetValue<CalculationSchema>
  consumptionTaxRate: number
  errors: FieldErrors<CalculationSchema>
}

export function CustomerTransferFeeRateRow({
  customerTransferFeeRate,
  exCustomerTransferFeeRate,
  setValue,
  consumptionTaxRate,
  errors,
}: Props) {
  return (
    <StyledCalculatorRowDiv>
      <FormField
        label="送客手数料率(税込)"
        type="number"
        placeholder="Placeholder"
        hint={`${customerTransferFeeRate}%`}
        disabled
        value={customerTransferFeeRate}
      />
      <span>=</span>
      <FormField
        label="送客手数料率(税抜)"
        type="number"
        placeholder="Placeholder"
        hint={`${exCustomerTransferFeeRate}%`}
        onChange={(e) => {
          setValue("exCustomerTransferFeeRate", Number(e.target.value))
        }}
        errorText={errors?.exCustomerTransferFeeRate?.message}
        value={exCustomerTransferFeeRate}
      />
      <span>x ( 1 +</span>
      <FormField
        label="消費税率"
        type="number"
        placeholder="Placeholder"
        hint={`${consumptionTaxRate}%`}
        onChange={(e) => {
          setValue("consumptionTaxRate", Number(e.target.value))
        }}
        errorText={errors?.consumptionTaxRate?.message}
        value={consumptionTaxRate}
      />
      <span>)</span>
    </StyledCalculatorRowDiv>
  )
}

const StyledCalculatorRowDiv = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`
